import React, { forwardRef } from 'react';
import './form-input.scss';
export var FormInput = forwardRef(function (_a, ref) {
    var id = _a.id, _b = _a.type, type = _b === void 0 ? 'text' : _b, value = _a.value, placeHolder = _a.placeHolder, error = _a.error;
    var inputClasses = 'c-form-input';
    if (error) {
        inputClasses += ' isInvalid';
    }
    return (React.createElement("input", { type: type, id: id, name: id, defaultValue: value, placeholder: placeHolder, className: inputClasses, ref: ref, "aria-invalid": error ? 'true' : 'false' }));
});
FormInput.displayName = 'FormInput';
